import { DOCUMENT } from '@angular/common'
import { Inject, Injectable, OnDestroy } from '@angular/core'
import { environment } from '../../environments/environment'
import { GlobalService } from './global.service'
import { isParkingDiscoveryRoute, ParkingModelContext, registerParkingWebMcp } from './parking-webmcp'

@Injectable({ providedIn: 'root' })
export class ParkingWebMcpService implements OnDestroy {
    private registration: AbortController | null = null

    constructor(@Inject(DOCUMENT) private document: Document, private globalService: GlobalService) {}

    syncRoute(url: string): void {
        const context = (this.document as Document & { modelContext?: ParkingModelContext }).modelContext
        if (!context || this.globalService.isEnterprise || !isParkingDiscoveryRoute(url)) {
            this.stop()
            return
        }
        if (this.registration) return
        const registration = new AbortController()
        this.registration = registration
        const apiBase = environment.useEmulators
            ? `${environment.functionsUrl}/publicParkingApi`
            : '/api/parking'
        void registerParkingWebMcp(context, apiBase, registration.signal).catch(error => {
            if (!registration.signal.aborted) console.warn('ParkUpp WebMCP registration failed', error)
            registration.abort()
            if (this.registration === registration) this.registration = null
        })
    }

    private stop(): void {
        this.registration?.abort()
        this.registration = null
    }

    ngOnDestroy(): void { this.stop() }
}
